(() => {
  const instances = new Map();

  class CtrLandingDailyAssessments {
    constructor(section) {
      this.section = section;
      this.sectionId = section.dataset.sectionId || "";
      this.mobileQuery = window.matchMedia("(max-width: 989px)");
      this.groups = Array.from(section.querySelectorAll("[data-ctr-days-group]")).map((group) => ({
        element: group,
        tabsWrap: group.querySelector(".ctr-landing-daily__tabs"),
        tabs: Array.from(group.querySelectorAll("[data-ctr-day-tab]")),
        items: Array.from(group.querySelectorAll("[data-ctr-day-item]")),
        isOpen: false,
        activeIndex: 0
      }));

      this.onBlockSelect = this.onBlockSelect.bind(this);
      this.handleTabClick = this.handleTabClick.bind(this);
      this.handleDocumentClick = this.handleDocumentClick.bind(this);

      this.bind();
      this.groups.forEach((group) => this.show(group, 0));
    }

    bind() {
      this.groups.forEach((group) => {
        group.tabs.forEach((tab) => tab.addEventListener("click", this.handleTabClick));
      });
      document.addEventListener("shopify:block:select", this.onBlockSelect);
      document.addEventListener("click", this.handleDocumentClick);
    }

    handleTabClick(event) {
      event.preventDefault();
      const tab = event.currentTarget;
      const group = this.groups.find((item) => item.element.contains(tab));
      if (!group) return;
      const index = group.tabs.indexOf(tab);
      if (index < 0) return;

      if (!this.mobileQuery.matches) {
        this.show(group, index);
        return;
      }

      const isActive = index === group.activeIndex;
      if (isActive) {
        this.toggleDropdown(group, !group.isOpen);
        return;
      }

      this.show(group, index);
      this.toggleDropdown(group, false);
    }

    onBlockSelect(event) {
      const detail = event.detail || {};
      if (detail.sectionId !== this.sectionId) return;
      if (!detail.blockId) return;

      this.groups.forEach((group) => {
        const index = group.tabs.findIndex((tab) => tab.dataset.blockId === detail.blockId);
        if (index > -1) {
          this.show(group, index);
          this.toggleDropdown(group, false);
        }
      });
    }

    handleDocumentClick(event) {
      if (!this.mobileQuery.matches) return;
      this.groups.forEach((group) => {
        if (!group.isOpen) return;
        if (!group.element.contains(event.target)) {
          this.toggleDropdown(group, false);
        }
      });
    }

    toggleDropdown(group, shouldOpen) {
      group.isOpen = shouldOpen;
      if (group.tabsWrap) {
        group.tabsWrap.classList.toggle("is-open", shouldOpen);
      }
      this.updateDropdownLayout(group);
    }

    show(group, index) {
      if (!group.tabs.length) return;
      const boundedIndex = Math.max(0, Math.min(index, group.tabs.length - 1));
      const activeBlockId = group.tabs[boundedIndex].dataset.blockId;
      group.activeIndex = boundedIndex;

      group.tabs.forEach((tab, tabIndex) => {
        const isActive = tabIndex === boundedIndex;
        tab.classList.toggle("is-active", isActive);
        tab.setAttribute("aria-selected", isActive ? "true" : "false");
      });

      group.items.forEach((item) => {
        const isActive = item.dataset.blockId === activeBlockId;
        item.classList.toggle("is-active", isActive);

        if (item.dataset.ctrHideInactive === "true") {
          item.hidden = !isActive;
        }
      });

      this.updateDropdownLayout(group);
    }

    updateDropdownLayout(group) {
      const activeTab = group.tabs[group.activeIndex];
      if (group.tabsWrap && activeTab && this.mobileQuery.matches) {
        group.tabsWrap.style.minHeight = `${activeTab.offsetHeight}px`;
      } else if (group.tabsWrap) {
        group.tabsWrap.style.removeProperty("min-height");
      }

      if (!this.mobileQuery.matches || !group.isOpen) {
        group.tabs.forEach((tab) => tab.style.removeProperty("--ctr-dropdown-offset"));
        if (group.tabsWrap) {
          group.tabsWrap.style.removeProperty("--ctr-dropdown-menu-height");
        }
        return;
      }

      let offset = 6;
      group.tabs.forEach((tab, tabIndex) => {
        if (tabIndex === group.activeIndex) {
          tab.style.removeProperty("--ctr-dropdown-offset");
          return;
        }

        tab.style.setProperty("--ctr-dropdown-offset", `${offset}px`);
        offset += tab.offsetHeight;
      });

      if (group.tabsWrap) {
        group.tabsWrap.style.setProperty("--ctr-dropdown-menu-height", `${Math.max(offset - 6, 0)}px`);
      }
    }

    destroy() {
      this.groups.forEach((group) => {
        group.tabs.forEach((tab) => tab.removeEventListener("click", this.handleTabClick));
      });
      document.removeEventListener("shopify:block:select", this.onBlockSelect);
      document.removeEventListener("click", this.handleDocumentClick);
    }
  }

  const init = (root) => {
    const section = root?.querySelector?.("[data-ctr-landing-daily]") || root;
    if (!section || !section.matches("[data-ctr-landing-daily]")) return;
    if (instances.has(section)) return;
    instances.set(section, new CtrLandingDailyAssessments(section));
  };

  const unload = (root) => {
    const section = root?.querySelector?.("[data-ctr-landing-daily]") || root;
    if (!section || !section.matches("[data-ctr-landing-daily]")) return;
    const instance = instances.get(section);
    if (!instance) return;
    instance.destroy();
    instances.delete(section);
  };

  const initAll = () => {
    document.querySelectorAll("[data-ctr-landing-daily]").forEach((section) => init(section));
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", (event) => init(event.target));
  document.addEventListener("shopify:section:unload", (event) => unload(event.target));
})();
